import { defineMessages } from 'react-intl';

var messages = defineMessages({
    eventTime: {
        'id': 'boxui.readableTime.eventTime',
        'defaultMessage': '{time, date, medium}'
    },
    eventTimeToday: {
        'id': 'boxui.readableTime.eventTimeToday',
        'defaultMessage': 'Today at {time, time, short}'
    },
    eventTimeYesterday: {
        'id': 'boxui.readableTime.eventTimeYesterday',
        'defaultMessage': 'Yesterday at {time, time, short}'
    },
    eventTimeDate: {
        'id': 'boxui.readableTime.eventTimeDate',
        'defaultMessage': '{time, date, medium} at {time, time, short}'
    },
    eventTimeDateShort: {
        'id': 'boxui.readableTime.eventTimeDateShort',
        'defaultMessage': '{date} at {time, time, short}'
    }
});

export default messages;